import * as z from "zod";

export const getRichpanelConnectionStatus = {
  name: "getRichpanelConnectionStatus" as const,
  input: z.null(),
  output: z.object({
    connected: z.boolean(),
    account: z.nullable(z.string()),
    smsPhoneNumber: z.nullable(z.string()),
    /** Richpanel rejected our credentials; the merchant must reconnect. */
    needsReauth: z.boolean(),
    /**
     * The URL and token the merchant's Richpanel HTTP Target sends. Optional
     * so a client deployed before its server still parses the old response.
     */
    webhook: z.object({ callbackUrl: z.string(), token: z.string() }).nullish(),
  }),
};
